import * as Website from '../../Config/Website.js';
import Technology from './modules/TechnologyImg.js';


const preinit = () => {

}

const init = () => {
  Technology();
}

const resize = () => {

}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}